import useMetaTags from 'react-metatags-hook';

type Options = {
  title?: string;
};

export function useMetaData(options?: Options) {
  useMetaTags({
    title: `Gran DT ${options?.title ? `| ${options.title}` : ''}`,
    description: `Gran DT description`,
    charset: 'utf8',
    lang: 'es',
  });
}
